import { render, staticRenderFns } from "./2_2_davichNewsDetail.vue?vue&type=template&id=9ccd150a&scoped=true&"
import script from "./2_2_davichNewsDetail.vue?vue&type=script&lang=js&"
export * from "./2_2_davichNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./2_2_davichNewsDetail.vue?vue&type=style&index=0&id=9ccd150a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccd150a",
  null
  
)

export default component.exports